import { logError } from "common/error";
import { delayAnimation } from "common/promises";
import { Sheets } from "common/sheets";
export class Shade {
    constructor(pixiContext, sheets) {
        this.walkListener = new WalkListener(pixiContext, this);
        this.sprite = Sheets.sprite(sheets, imageName);
        this.sprite.alpha = 0.9;
    }
}
class WalkListener {
    constructor(pixiContext, shade) {
        this.pixiContext = pixiContext;
        this.shade = shade;
    }
    walk(time) {
        this.animation(time).catch(logError);
    }
    async animation(time) {
        this.bounce();
        await delayAnimation(time / 2);
        this.bounce();
    }
    async bounce() {
        const time = 250;
        await this.pixiContext.animate({
            durationMS: time / 2,
            start: 0.9,
            destination: 0.5,
            setter: (value) => {
                this.shade.sprite.alpha = value;
            },
        });
        await this.pixiContext.animate({
            durationMS: time / 2,
            start: 0.5,
            destination: 0.9,
            setter: (value) => {
                this.shade.sprite.alpha = value;
            },
        });
    }
}
export const imageName = "쉐이드-min.png";
//# sourceMappingURL=shade.js.map